export function kebabToCamelCase(input: string): string;
export function kebabToCamelCase(input: undefined): undefined;

export function kebabToCamelCase(input: string | undefined): string | undefined {
  if (!input) {
    return;
  }

  return input.replace(/-([a-z])/g, (g: string): string => g[1].toUpperCase());
}
